<template>
  <!-- 전속중개계약 2페이지 -->
  <div class="col-lg-10 col-md-11 col-sm-12 m-auto">
    <div class="jipvio-contract contract">
      <img src="/../img/contract2.jpg" />

      <!-- p2-line1 (권리이전용 체크(매도, 임대)) -->
      <div class="con-line" id="con2-line1">
        <div class="con-line-div" id="con2-line1-div1">
          <input type="checkbox" disabled="disabled" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con2-line1-div2">
          <ValidationProvider
            ref="p2LeaseCheckVal"
            vid="p2LeaseCheckVal"
            rules="required|true"
          >
            <input
              ref="p2LeaseCheckBox"
              type="checkbox"
              class="con-line-input"
              v-model="p2LeaseCheck"
            />
          </ValidationProvider>
        </div>
        <div class="con-line-div" id="con2-line1-div3">
          <input type="checkbox" disabled="disabled" class="con-line-input" />
        </div>
        <div class="con-line-div" id="con2-line1-div4">
          <input disabled="disabled" class="con2-line1-input" />
        </div>
      </div>

      <!-- p2-line2 소유자 및 등기명의인 성명, 생년월일 -->
      <div class="con-line" id="con2-line2">
        <div class="con-line-div" id="con2-line2-div1">
          <input
            class="con-line-input"
            v-model="certification.ownerName"
            disabled
          />
        </div>
        <div class="con-line-div" id="con2-line2-div2">
          <input class="con-line-input" v-model="clientBirth" disabled />
        </div>
      </div>

      <!-- p2-line3 소유자 및 등기명의인 주소 -->
      <div class="con-line" id="con2-line3">
        <div class="con-line-div" id="con2-line3-div1">
          <input class="con-line-input" v-model="ownerFullAddr" disabled />
        </div>
      </div>

      <!-- p2-line4 (중개대상물-> 건축물 소재지, 건축년도) -->
      <div class="con-line" id="con2-line4">
        <div class="con-line-div" id="con2-line4-div1">
          <input
            class="con-line-input"
            v-model="certification.fullJAddr"
            disabled
          />
        </div>
        <div class="con-line-div" id="con2-line4-div2">
          <input
            class="con-line-input"
            v-model="certification.buildYear"
            disabled
          />
        </div>
      </div>

      <!-- p2-line5 (중개대상물 건축물 면적, 구조, 용도) -->
      <div class="con-line" id="con2-line5">
        <div class="con-line-div" id="con2-line5-div1">
          <input class="con-line-input" v-model="finalUseArea" disabled />
        </div>
        <div class="con-line-div" id="con2-line5-div2">
          <input
            class="con-line-input"
            v-model="certification.strct"
            disabled
          />
        </div>
        <div class="con-line-div" id="con2-line5-div3">
          <input
            class="con-line-input"
            v-model="certification.purpsDetail"
            disabled
          />
        </div>
      </div>

      <!-- p2-line6 (토지 소재지, 지목) -->
      <div class="con-line" id="con2-line6">
        <div class="con-line-div" id="con2-line6-div1">
          <input
            class="con-line-input"
            v-model="certification.propertyJAddr"
            disabled
          />
        </div>
        <div class="con-line-div" id="con2-line6-div2">
          <input
            class="con-line-input"
            v-model="certification.platGbCdNm"
            disabled
          />
        </div>
      </div>

      <!-- p2-line7 (토지 면적, 지역, 용도) -->
      <div class="con-line" id="con2-line7">
        <div class="con-line-div" id="con2-line7-div1">
          <input
            class="con-line-input"
            v-model="certification.platArea"
            disabled
          />
        </div>
        <div class="con-line-div" id="con2-line7-div2">
          <input
            class="con-line-input"
            v-model="certification.brdList"
            disabled
          />
        </div>
        <div class="con-line-div" id="con2-line7-div3">
          <input
            class="con-line-input"
            v-model="certification.platGbCdNm"
            disabled
          />
        </div>
      </div>

      <!-- p2-line8 (은행융자, 권리금, 제세공과금 등) -->
      <div class="con-line" id="con2-line8">
        <div class="con-line-div" id="con2-line8-div1">
          <ValidationProvider
            ref="otherFeeVal"
            vid="otherFeeVal"
            rules="required"
          >
            <input
              ref="otherFeeBox"
              class="con-line-input"
              v-model="otherFee"
            />
          </ValidationProvider>
        </div>
      </div>

      <!-- p2-line9 (권리관계) -->
      <div class="con-line" id="con2-line9">
        <div class="con-line-div" id="con2-line9-div1">
          <ValidationProvider
            ref="rightRelVal"
            vid="rightRelVal"
            rules="required"
          >
            <input
              ref="rightRelBox"
              class="con-line-input"
              v-model="rightRel"
            />
          </ValidationProvider>
        </div>
      </div>

      <!-- p2-line10 (거래규제 및 공법상 제한사항) -->
      <div class="con-line" id="con2-line10">
        <div class="con-line-div" id="con2-line10-div1">
          <input class="con-line-input" v-model="regulation" />
        </div>
      </div>

      <!-- p2-line11 (중개의뢰 금액) -->
      <div class="con-line" id="con2-line11">
        <div class="con-line-div" id="con2-line11-div1">
          <label for="yearrent"></label>
          <select id="yearrent" v-model="leaseYn">
            <option selected value="1">전세</option>
            <option value="0">월세</option>
          </select>

          <!-- <input
                  type="radio"
                  id="yearrent"
                  name="renttype"
                  v-model="leaseYn"
                  value="1"
                  @click="monthlyPay = null"
                />
                <label for="yearrent">전세</label>
                <input type="radio" id="monthrent" name="renttype" v-model="leaseYn" value="0" />
                <label for="montrent">월세</label> -->
        </div>

        <div class="con-line-div" id="con2-line11-div2">
          <ValidationProvider ref="depositVal" vid="depositVal" rules="required"
            ><!-- | numeric -> 값이 rules에 들어가면 숫자만 인식함 -->
            <label for="con2-line11-div2-input1">보증금</label>
            <input
              ref="depositBox"
              type="text"
              id="con2-line11-div2-input1"
              v-model="deposit"
              @input="toFormattedValue()"
            />
            <label for="con2-line11-div2-input1">원</label>
          </ValidationProvider>
        </div>

        <div
          class="con-line-div"
          id="con2-line11-div3"
          v-if="Number(leaseYn) === 0"
        >
          <ValidationProvider
            ref="monthlyPayVal"
            vid="monthlyPayVal"
            rules="required|numeric"
          >
            <label for="con2-line11-div3-input1">월세</label>
            <input
              ref="monthlyPayBox"
              type="number"
              id="con2-line11-div3-input1"
              v-model="monthlyPay"
            />
            <label for="con2-line11-div3-input1">원</label>
          </ValidationProvider>
        </div>
      </div>

      <!-- p2-line12 (그 밖의 사항) -->
      <div class="con-line" id="con2-line12">
        <div class="con-line-div" id="con2-line12-div1">
          <input class="con-line-input" v-model="etc" />
        </div>
      </div>

      <!--p2-line13 이전,  다음 버튼 -->
      <div class="con-line" id="con2-line13">
        <div class="con-line-div" id="con2-line13-div1">
          <el-button class="btn con2-line13-btn" @click="$emit('ToPage1')">
            이전페이지
          </el-button>
        </div>

        <div class="con-line-div" id="con2-line13-div2">
          <el-button class="btn con2-line13-btn" @click="ToPage3">
            다음페이지
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Row, Button, Tooltip, Upload, Checkbox, Message } from "element-ui";
import { createNamespacedHelpers, mapGetters } from "vuex";
import numeral from "numeral";

const { mapGetters: sessionMapGetters } = createNamespacedHelpers(
  "loginSession"
);

export default {
  props: ["clientBirth"],

  components: {
    [Row.name]: Row,
    [Button.name]: Button,
    [Tooltip.name]: Tooltip,
    [Upload.name]: Upload,
    [Checkbox.name]: Checkbox,
    [Message.name]: Message
  },

  data() {
    return {
      //contract 2
      p2LeaseCheck: null, //page2 권리이전용 구분- 임대 체크박스

      ownerBirth: null, //소유주 생년월일

      buildingAddr: null, //건축물 소재지
      buildYear: null, //건축년도
      buildingArea: null, //건축물 면적
      buildingStruct: null, //건축물 구조
      buildingPurpose: null, //건축물 용도

      otherFee: null, // 은행융자, 권리금, 제세공과금 등

      rightRel: null, // 권리관계
      regulation: null, //거래규제 및 공법상 제한사항
      leaseYn: "1",
      deposit: null, //중개의뢰금액 보증금
      monthlyPay: null, //중개의뢰금액 월세
      etc: null //그 밖의 사항
    };
  },

  created() {
    this.bringData();
  },

  computed: {
    ...sessionMapGetters({
      sessionPropertyInquiry: "getPropertyInquiry"
    }),

    certification() {
      return this.sessionPropertyInquiry.certification;
    },

    ownerFullAddr() {
      return (
        this.sessionPropertyInquiry.certification.ownerAddr +
        " " +
        this.sessionPropertyInquiry.certification.ownerAddrDetail
      );
    },

    finalUseArea() {
      if (this.certification.partArea != 0) {
        return this.certification.partArea;
      } else {
        return this.certification.useArea;
      }
    }
  },

  methods: {
    bringData() {
      //contract 2
      this.p2LeaseCheck = this.sessionPropertyInquiry.contractInfo.p2LeaseCheck; //page2 권리이전용 구분- 임대 체크박스

      this.otherFee = this.sessionPropertyInquiry.contractInfo.otherFee; // 은행융자, 권리금, 제세공과금 등

      this.rightRel = this.sessionPropertyInquiry.contractInfo.rightRel; // 권리관계
      this.regulation = this.sessionPropertyInquiry.contractInfo.regulation; //거래규제 및 공법상 제한사항

      this.leaseYn = Number(
        this.sessionPropertyInquiry.contractInfo.leaseYn
      ).toString();

      this.deposit = this.sessionPropertyInquiry.contractInfo.deposit; //중개의뢰금액 보증금
      this.monthlyPay = this.sessionPropertyInquiry.contractInfo.monthlyPay; //중개의뢰금액 월세
      this.etc = this.sessionPropertyInquiry.contractInfo.etc; //그 밖의 사항
    },

    SendContract2Data() {
      let Data = {
        p2LeaseCheck: this.p2LeaseCheck,
        ownerBirth: this.ownerBirth,
        buildingAddr: this.buildingAddr,
        buildYear: this.buildYear,
        buildingArea: this.buildingArea,
        buildingStruct: this.buildingStruct,
        buildingPurpose: this.buildingPurpose,
        otherFee: this.otherFee,
        rightRel: this.rightRel,
        regulation: this.regulation,
        leaseYn: this.leaseYn,
        deposit: this.deposit,
        monthlyPay: this.monthlyPay,
        etc: this.etc
      };
      this.$emit("SendContract2Data", Data);
    },

    toFormattedValue() {
      this.deposit = numeral(this.deposit).format("0,0");
    },

    // focus() {
    //   this.$nextTick(() => {
    //   this.$refs.p2LeaseCheckBox.focus();
    // });
    // },

    ToPage3() {
      let errMsg = [];

      if (this.p2LeaseCheck == false || this.p2LeaseCheck == null) {
        errMsg.push({
          message: "2페이지 구분에 임대 체크박스를 확인해주세요.",
          ref: "p2LeaseCheckBox"
          // IsfocusRequireEl: false,
          // pageNum: 2
        });
      }
      if (this.otherFee == "" || this.otherFee == null) {
        errMsg.push({
          message:
            "2페이지 구분에 중개대상물(은행융자, 권리금, 제세공과금 등)를 확인해주세요.",
          ref: "otherFeeBox"
          // IsfocusRequireEl: false,
          // pageNum: 2
        });
      }
      if (this.rightRel == "" || this.rightRel == null) {
        errMsg.push({
          message: "2페이지 권리관계를 확인해주세요.",
          ref: "rightRelBox"
          // IsfocusRequireEl: false,
          // pageNum: 2
        });
      }
      if (this.deposit == 0 || this.deposit == null) {
        errMsg.push({
          message: "2페이지 보증금을 확인해주세요.",
          ref: "depositBox"
          // IsfocusRequireEl: false,
          // pageNum: 2
        });
      }

      if (
        this.leaseYn == "0" &&
        (this.monthlyPay == null ||
          this.monthlyPay == "" ||
          this.monthlyPay == 0)
      ) {
        errMsg.push({
          message: "2페이지 월세를 확인해주세요.",
          ref: "monthlyPayBox"
          // IsfocusRequireEl: false,
          // pageNum: 2
        });
      }

      if (errMsg.length == 0) {
        this.$emit("contractNum", 3);
        window.scrollTo(0, 420);
        return;
      }

      if (errMsg[0] != null) {
        // this.contractNum = errMsg[0].pageNum;
        this.$nextTick(() => {
          this.$refs[errMsg[0].ref].focus();
        });
        Message({
          message: errMsg[0].message,
          type: "error"
        });
      }

      if (errMsg[1] != null) {
        Message({
          message: errMsg[1].message,
          type: "error",
          offset: 60
        });
      }

      if (errMsg[2] != null) {
        Message({
          message: errMsg[2].message,
          type: "error",
          offset: 100
        });
      }
    }
  }
};
</script>

<style></style>
